import React from 'react';
import HomeViewLayout from './components/HomeViewLayout';

function HomeView() {

    return (
        <div>
            <HomeViewLayout/>
        </div>
    );
}

export default HomeView;



// WEBPACK FOOTER //
// ./src/views/Home/HomeView.js